<template>
  <div ref="leftColumn" class="left-column">
    <h1 class="top-title">
      <span class="line">Materiality</span>
    </h1>

    <p v-if="lang !== 'ENG'" class="bottom-text text-center">
      <span class="line">SK주식회사가 중요하게 인식하는 ESG 이슈를 식별하고</span>
      <span class="line">이에 대한 전략 및 대응방안을 수립합니다.</span>
    </p>
    <p v-else class="bottom-text text-center en-font">
      <span class="line">SK Inc. identifies ESG issues of material importance and </span>
      <span class="line">establishes strategic responses to address them effectively.</span>
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'MaterialityTop',
  data() {
    return {
      observer: null,
      visibleTimestamp: 0
    };
  },
  computed: {
    ...mapState('report_list', ['lang'])
  },
  mounted() {
    const options = {
      rootMargin: '-20% 0px 0px 0px',
      threshold: 0.2
    };

    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          this.visibleTimestamp = Date.now();
        } else {
          if (Date.now() - this.visibleTimestamp > 1000) {
            entry.target.classList.remove('is-visible');
          }
        }
      });
    }, options);

    this.observer.observe(this.$refs.leftColumn);
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
};
</script>

<style scoped>
.left-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  box-sizing: border-box;
}

.top-title,
.bottom-text {
  overflow: hidden;
  padding: 5px 0;
}

.top-title {
  font-size: clamp(40px, 5vw, 80px);
  font-weight: 600;
  color: #000;
}

.bottom-text {
  font-size: clamp(16px, 3vw, 32px);
  line-height: 1.6;
  color: #000;
}

.bottom-text.en-font {
  font-size: clamp(19.2px, 2.4vw, 25.6px);
}

.line {
  display: block;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.left-column.is-visible .line {
  opacity: 1;
  transform: translateY(0);
}

.left-column.is-visible .top-title .line {
  transition-delay: 0.2s;
}

.left-column.is-visible .bottom-text .line:nth-child(1) {
  transition-delay: 0.4s;
}

.left-column.is-visible .bottom-text .line:nth-child(2) {
  transition-delay: 0.6s;
}
</style>
